import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetStatementRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetStatementResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getStatement = (request: GetStatementRequest, options?: CashRequestOptions) =>
  post<GetStatementRequest, GetStatementResponse>('/2.0/cash/get-statement', request, {
    ...options,
    rejectOnError: true,
  })
